import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OPPORTUNITY_SOURCES } from "@/api/types";
import { PurchasesPage } from "@/features/purchases/purchases-page";
import { baseListSearch, optionalDate, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/purchases/")({
  validateSearch: z.object({
    ...baseListSearch,
    organizationId: optionalString,
    storeId: optionalString,
    source: optionalEnum(OPPORTUNITY_SOURCES),
    from: optionalDate,
    to: optionalDate,
    trace: optionalString,
  }),
  head: () => ({ meta: [{ title: "Purchases · Rogue Admin" }] }),
  component: PurchasesPage,
});
